/**
 * Message Action Icons
 *
 * Holds shared message action icon constants without importing action
 * components.
 *
 * Primary responsibilities:
 * - Export shared message action icon sizes
 * - Keep selector and action components from depending on each other
 *
 * Dependencies:
 * - none
 */

export const MESSAGE_ICON_SIZE = 18
